<template>

<div id="app">
  <v-app id="inspire">
      
    <v-layout fill-height>
      <v-flex xs12 align-end flexbox>
        <v-card v-if="this.$route.params.infoText=='The Tomb-Shrine, Samadhi of Avatar Meher Baba'">
			<v-card-media src="/static/doc-images/lists/samahdiSacred.jpg" height="250px">
			</v-card-media>
			  <v-card-title primary-title>
				<div>
				  <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
				  <div>
					<p style="text-align:justify">The most sacred place associated with Avatar Meher Baba is His Tomb-Shrine.
						   When He decided to move the Meher Ashram SCHOOL to the hill In June 1927,
							Baba chose this site to have a small hut of bamboo matting and steel sheets built. 
							Soon after, He ordered a pit to be dug on this spot. 
							This pit was made more permanent with stone masonry, and small steps were built leading down into the crypt. 
							A wooden cabin was constructed again over the crypt and a platform was built extending from the east wall of 
							the crypt so that Baba could greet visitors and gather with the ashram boys there. 
							In August 1927 Baba began spending His nights here, and on 10th November 1927,
							 He began a 5½-month period of seclusion and fasting. 
							 During that time, He advanced many of the ashram boys spiritually, 
							 giving them profound inner experiences.</p>
					<p style="text-align:justify">In 1929 the wooden walls were replaced with soft stone construction</p>
					<p style="text-align:justify">In 1938 the crypt was rebuilt into what is seen today with stones from the Post Office building.
						 The symbols over the corners are the Zoroastrian flame, the Hindu temple, the Christian cross and 
						 the Muslim mosque. 
						 Later that year, under Baba’s direction, the Swiss artist Helen Dahm painted the interior murals.</p>
					<p style="text-align:justify">Baba instructed that wherever He dropped His body, 
						His physical form was to be brought to Meherabad and interred in the Tomb. 
						And so it was on 31st January 1969 that Beloved Baba's body, 
						the form that housed reality in illusion was brought from Meherazad to rest here for all time. 
						Baba declared that 60 years after dropping His body, 
						His Tomb-Shrine would be a major place of pilgrimage for the world.</p>
						<p style="text-align:center"><v-btn id="button" @click="samadhi"><v-icon>directions_walk</v-icon> Walk to Samadhi</v-btn></p>
				   </div>
				</div>
			  </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='Meher Retreat'">
          <v-card-media src="/static/doc-images/lists/MeherRetreat.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">The ground floor of this building was originally a double 
                    water tank constructed by the British Army to supply the POW camp down the hill. 
                    Baba stayed in seclusion in the tank rooms periodically during the 1920s, and 1930. 
                    In June 1927, the east and west doorways were cut through the thick rock walls. 
                    The East Room was used as a dormitory and 
                    the West Room as an assembly hall for the boys of the Meher Ashram School.</p>
                <p style="text-align:justify">In 1933, the East Room became home to Baba’s close women mandali, 
                    where Mehera and the women were strictly sequestered, 
                    living a life of obedience, poverty and purity. 
                    From then until The New Life, Meher Retreat was used exclusively for women’s quarters. 
                    The upper story of the Retreat was built in 1938 as Baba expanded the women’s ashram. 
                    Baba’s meetings with His women mandali preceding the New Life took place here, 
                    after which the ashram was disbanded for the most part 
                    (with only Mansari and the Kaikobad family remaining on the Hill).</p>
                <p style="text-align:justify">Later, the upper story and the West Room were used to quarter 
                    Western men during the 1954 Sahavas program. 
                    The West Room is now a museum and is open at regularly scheduled times. 
                    The South Room has become a library and the upper story is currently 
                    the Meherabad Hill Library exhibition and meeting space.</p>
					<p style="text-align:center"><v-btn id="button" @click="retreat"><v-icon>directions_walk</v-icon> Walk to Meher Retreat</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='The Dhuni of Meherabad'">
          <v-card-media src="/static/doc-images/lists/dhuni.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">On the evening of 10th November 1925, local villagers came to 
                    Baba pleading for rain to save them from an extreme drought. 
                    Baba ordered that a pit be dug and a fire lit. 
                    After some devotional music, Baba asked the villagers to depart quickly, 
                    but by the time they reached their homes, 
                    some were drenched by torrential rain, which lasted fifteen hours.</p>
                <p style="text-align:justify">On 12th December 1941, during one of His seclusion periods, 
                    Baba came down the Hill to the Dhuni. 
                    To maintain His seclusion, He had the area around the Dhuni curtained off. 
                    Allowing only four of the mandali to be present, one of them lit the Dhuni. 
                    One month later, on 12th January 1942, 
                    Baba had the Dhuni lit in honor of Upasni Maharaj who had recently dropped his body. 
                    From that day, Baba ordered that the Meherabad Dhuni be lit on the 12th of every month. 
                    The current platform around the pit was built in 1948. 
                    Meher Baba last attended the lighting of the Dhuni on 12th November 1955. 
                    At that time, He asked all attending to sacrifice some desire or shortcoming to the Dhuni. 
                    This custom has been followed since then.</p>
				<p style="text-align:center"><v-btn id="button" @click="dhuni"><v-icon>directions_walk</v-icon> Walk to Dhuni</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='The Original Well'">
          <v-card-media src="/static/doc-images/lists/Originalwell.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">During the mid-1920s, 
                    Meher Baba’s closest woman disciple, Mehera, 
                    would wash Baba's clothes on the large flat stones in the moat to the east of the Original Well. 
                    Once during the early days of Meherabad, after Gulmai washed Baba's feet, 
                    Baba had the wash water poured into the well and commented, 
                    “The water from this well will always be my prasad”.</p>
				<p style="text-align:center"><v-btn id="button" @click="well"><v-icon>directions_walk</v-icon> Walk to Original Well</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='The Main Bungalow (also known as Mandali Hall)'">
          <v-card-media src="/static/doc-images/lists/MainBungulaow.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">THE MAIN BUNGALOW was erected in 1948 to provide a large, 
                    new meeting hall, which became known as Mandali Hall. 
                    The bungalow also provided living quarters for men mandali and a medical dispensary. 
                    Baba’s momentous meetings with His men mandali, 
                    preparing for the New Life, took place here, 
                    as well as several sahavas and darshan programs in the 1950s.</p>
                <p style="text-align:justify">Mohammed Mast lived in the hall for many years and 
                    later in a more private room at the south end of the building. 
                    Facing the bungalow from the west, Padri’s room can be seen just to the left of Mandali Hall. 
                    It is furnished much as it was when he was alive and gives an idea of the comparative comfort 
                    the mandali were allowed in the later years. 
                    This room also contained Padri’s homeopathic dispensary from which 
                    he treated many patients until his death in 1982.</p>
				<p style="text-align:center"><v-btn id="button" @click="bungalow"><v-icon>directions_walk</v-icon> Walk to Main Bungalow</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='The Tomb of Gilori Shah & The Neem Tree'">
          <v-card-media src="/static/doc-images/lists/GloriaShahTomb.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">Kaikhushru and Gulmai’s family was acquainted with Gilori Shah, 
                    a Mohammedan saint of Ahmednagar, who began urging them to give him a small plot on the property. 
                    Early in 1923, Kaikhushru agreed to his request. 
                    But when Gilori Shah informed his followers, they questioned his choice of this site for his tomb, 
                    since it was so desolate and distant from the city. 
                    He told them that soon "the Great One” would come and make His abode here. 
                    Gilori Shah insisted that construction of his tomb be completed as soon as possible. 
                    On 4th May 1923, Meher Baba first came to this site with some of His disciples, walking from Ahmednagar. 
                    He sat beneath the neem tree, near the ready but still vacant tomb of Gilori Shah. 
                    An old carpenter who would become Baba's first disciple from Arangaon supplied 
                    Baba’s group with simple millet bread and a bucket to draw water from the well, 
                    which is behind the Engine Room. 
                    This was the water source for the property and later became known as the Original Well.</p>
				<p style="text-align:center"><v-btn id="button" @click="shah"><v-icon>directions_walk</v-icon> Walk to Tomb of Gilori Shah</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='The Rahuri Cabin'">
          <v-card-media src="/static/doc-images/lists/rahuricabin.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">Now situated to the southeast of the Old Bungalow, 
                    THE RAHURI CABIN was named for the small town north of Ahmednagar where it was originally built. 
                    In 1936 Baba had an ashram for mad persons and a few masts in Rahuri, 
                    and this cabin served as His personal quarters there. 
                    By Baba’s order it was dismantled in 1937 and re-assembled at Meherabad. 
                    Baba then used it during periods of seclusion, and up until the late 1940s for interviews. 
                    Different masts were also accommodated here through the years.</p>
				<p style="text-align:center"><v-btn id="button" @click="cabin"><v-icon>directions_walk</v-icon> Walk to Rahuri Cabin</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>
        <v-card v-if="this.$route.params.infoText=='The Land'">
          <v-card-media src="/static/doc-images/lists/meherabadsign.jpg" height="250px">
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{this.$route.params.infoText}}</h3>
              <div>
                <p style="text-align:justify">THE PROPERTY THAT BECAME MEHERABAD had been developed as a 
                    British army POW camp during World War I. 
                    After the war the stock and equipment of the camp was auctioned off. 
                    The only structures left intact at the time were a post office building, a mess quarters, 
                    a bathroom building, a well near the road, 
                    and a large ground level water tank on the hill across the railway line. 
                    Except for the neem trees along the road, the land was barren and mostly unsuitable for agriculture. 
                    Kaikhushru and Gulmai Irani obtained this property in 1919. 
                    They were the parents of Rustom and Adi, two of Baba’s close men disciples.</p>
				<p style="text-align:center"><v-btn id="button" @click="land"><v-icon>directions_walk</v-icon> The Land</v-btn></p>
               </div>
            </div>
          </v-card-title>
        </v-card>                
      </v-flex>
    </v-layout>
  </v-app>
</div>
</template>
<script>
  export default {
    methods: {
      samadhi () {
        location.href = 'geo:<19.030994>,<74.714059>?q=<19.030994>,<74.714059>(The Tomb-Shrine, Samadhi of Avatar Meher Baba)'
      },
      retreat () {
        location.href = 'geo:<19.031159>,<74.714633>?q=<19.031159>,<74.714633>(Meher Retreat)'
      },
      dhuni () {
        location.href = 'geo:<19.029584>,<74.718436>?q=<19.029584>,<74.718436>(The Dhuni of Meherabad)'
      },
      well () {
        location.href = 'geo:<19.029016>,<74.718350>?q=<19.029016>,<74.718350>(The Original Well)'
      },
      bungalow () {
        location.href = 'geo:<19.028651>,<74.719369>?q=<19.028651>,<74.719369>(The Main Bungalow (also known as Mandali Hall))'
      },
      shah () {
        location.href = 'geo:<19.029163>,<74.718409>?q=<19.029163>,<74.718409>(The Tomb of Gilori Shah & The Neem Tree)'
      },
      cabin () {
        location.href = 'geo:<19.030101>,<74.719225>?q=<19.030101>,<74.719225>(The Rahuri Cabin)'
      },
      land () {
        location.href = 'geo:<19.029908>,<74.719015>?q=<19.029908>,<74.719015>(The Land)'
      }
    }
  }
</script>
<style>
.card__media {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    overflow: hidden !important;
    position: fixed !important;
    top: 50px !important;
    left: 0px !important;
    right: 0px !important;
    bottom: 0px !important;
}
.card__title--primary
	{
		
		margin-top:240px;
		left:0px !important;
		right:0px !important;
		overflow-y:scroll;        
	}
	.application--light .card {
    background-color: rgb(250,235,215) !important;
    color: rgba(0,0,0,0.87) !important;
}
#button {
background-color: rgb(83, 144, 204);
  margin: auto;
  display: block;
  color: white;
  text-transform: unset;
  width: auto;
 }
</style>


// WEBPACK FOOTER //
// marker.vue?755630d3